export default "__VITE_ASSET__d60c6c3e__"